const E2E_TEST_USER_EMAILS = [
  'e2e-invite-owner@finalytic.io',
  'e2e-invite-owner@vrp.rocks',
  'e2e-invite-member@finalytic.io',
  'e2e-invite-member@vrp.rocks',
  'e2e-sign-up-legacy@vrp.rocks',
  'e2e-sign-up-partner@vrp.rocks',
  'e2e-sign-up@finalytic.io',
  'e2e-sign-up@vrp.rocks',
  'lars+e2e@vrplatform.app',
  'lars+e2e-gl@vrplatform.app',
  'lars+checkly@finalytic.co',
] as const;

const E2E_TEST_USERS: Partial<
  Record<(typeof E2E_TEST_USER_EMAILS)[number], string>
> = {
  'e2e-invite-member@finalytic.io': '113d73d8-ee21-46b7-a12a-a74f632401ca',
  'e2e-invite-member@vrp.rocks': '113d73d8-ee21-46b7-a12a-a74f632401ca',
  'e2e-invite-owner@finalytic.io': '917b7c4e-cb03-491c-9e94-d33a5bdeca05',
  'e2e-invite-owner@vrp.rocks': '917b7c4e-cb03-491c-9e94-d33a5bdeca05',
  'e2e-sign-up-partner@vrp.rocks': '5c8e5572-74d0-4ae6-af73-bca8db9a27e9',
  'e2e-sign-up@vrp.rocks': '3c8e5572-74d0-4ae6-af73-bca8db9a27e9',
  'e2e-sign-up@finalytic.io': 'ec8e5572-74d0-4ae6-af73-bca8db9a27e9',
  'e2e-sign-up-legacy@vrp.rocks': 'ec8e5572-74d0-4ae6-af73-bca8db9a27e9',
  'lars+checkly@finalytic.co': '9e7dfc88-503c-4222-9905-9116169d2203',
};

export const isTestUser = ({
  userEmail,
  userId,
}: {
  userEmail?: string | null;
  userId?: string | null;
}) =>
  Boolean(
    (userId && Object.values(E2E_TEST_USERS).includes(userId)) ||
    (userEmail && Object.keys(E2E_TEST_USERS).includes(userEmail))
  );
